/**
 * `/merchandising/styles/$styleId/costing` — Costing & BOM, one of the Style
 * File's 7 process screens (garment Increment 1/2, M2).
 *
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { StyleCostingPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/styles/$styleId/costing")({
  component: StyleCostingRoute,
});

function StyleCostingRoute() {
  const { styleId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Merchandising", to: "/" },
        { label: "Style files", to: "/merchandising/styles" },
        { label: "Costing" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <StyleCostingPage styleId={styleId} />
    </WorkspaceShell>
  );
}
